import {
  getReq,
  postReq,
  putReq,
  delReq,
  findReq,
  allReq,
} from "@/axiosfiles/axios-outh";

// actions part
export const actions = {
  // Actions without mutations and states

  // eslint-disable-next-line
  // MultiRequest({ commit }, url) {
  //   return getReq(url).then(data => {
  //     return data;
  //   });
  // },
  GET_DATA_ONLY(undifined, url) {
    return getReq(url).then(data => {
      return data;
    });
  },
  // eslint-disable-next-line
  FIND_BY_VALUE({ commit }, { url, query }) {
    let params = {};
    if (query) params = { ...query };
    return allReq
      .get(url, {
        params,
      })
      .then(data => {
        return data;
      })
      .catch(err => {
        throw err;
      });
  },
  // eslint-disable-next-line
  FIND_BY_VALUE_ONLY({ commit }, info) {
    // console.log("aa heey");
    return findReq(info.url, info.ID);
  },
  // eslint-disable-next-line
  INSERT_ONLY({ commit }, value) {
    return postReq(value.url, value.data);
  },

  // Actions with mutations
  SelectAll({ commit }, obj) {
    // console.log(obj);
    return new Promise((resolve, reject) => {
      getReq(obj.url)
        .then(data => {
          resolve(200);
          // console.log(data);
          if (data.status == 200) commit(obj.MutName, data.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  INSERT_DATA({ commit }, value) {
    return postReq(value.url, value.data)
      .then(data => {
        // console.log(data.data);
        if (data.status == 200) {
          commit(value.MutName, data.data);
          return 200;
        }
      })
      .catch(() => {
        // console.log(err);
      });
  },
  // eslint-disable-next-line
  UPDATE_DATA_Only({ commit }, value) {
    return putReq(value.url, value.data);
  },
  // eslint-disable-next-line
  UPDATE_DATA({ commit }, value) {
    putReq(value.url, value.data)
      .then(data => {
        if (data.status == 200) commit(value.MutName, data.data);
      })
      .catch(() => {
        // console.log(err);
      });
  },
  DeleteInfo({ commit }, value) {
    delReq(value.url, value.data)
      .then(data => {
        if (data.status == 200) commit(value.MutName, data.data);
      })
      .catch(() => {
        // console.log(err);
      });
  },
};
//gettes part
